import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { isArray } from 'lodash';

import { useLoader } from 'Store/loader';
import { useToast } from 'Store/toast';
import { useModal } from 'Store/modal';

import deleteRuleset from 'Api/schedule-ruleset/deleteRuleset';

const useDeleteScheduleRuleset = () => {
  const { t } = useTranslation('schedule-ruleset');
  const queryClient = useQueryClient();
  const { onShowLoader, onResetLoader } = useLoader();
  const { onOpenToast, onResetToast } = useToast();
  const { onResetModal } = useModal();

  return useMutation({
    mutationFn: async (id) => {
      onShowLoader({ variant: 'loader-primary' });

      return await deleteRuleset({ id });
    },
    onSuccess: () => {
      onResetToast();
      onResetModal();
      queryClient.invalidateQueries({ queryKey: ['ruleset-list'] });

      onOpenToast({
        status: 'success',
        description: t('deleteSuccess'),
        duration: 5,
        alwaysShow: false,
      });
    },
    onError: (error) => {
      const errorMessage = isArray(error?.response?.data?.errors) ? error?.response?.data?.errors[0]?.message : t('deleteErrorDescription');
      onResetToast();

      onOpenToast({
        status: 'error',
        title: t('deleteErrorTitle'),
        description: errorMessage,
        duration: 5,
        alwaysShow: false,
      });
    },
    onSettled: () => {
      onResetLoader();
    },
  });
};

export default useDeleteScheduleRuleset;